import { render, staticRenderFns } from "./user-cards.vue?vue&type=template&id=424955b7&scoped=true"
import script from "./user-cards.vue?vue&type=script&lang=js"
export * from "./user-cards.vue?vue&type=script&lang=js"
import style0 from "./user-cards.vue?vue&type=style&index=0&id=424955b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424955b7",
  null
  
)

export default component.exports